module.exports = __webpack_public_path__ + "img/Jet_Station10.25a458be.jpg";